<template>
  <div
    class="addUser"
    ref="addUser"
  >
    <a-modal
      class=""
      title="修改"
      width="550px"
      :centered="true"
      v-model:visible="visible"
      :getContainer="()=>$refs.addUser"
      cancelText="取消"
      okText="确定"
      @ok="handleOk"
    >
      <a-form
        :label-col="labelCol"
        :model="formState"
      >
        <a-form-item label="线路名称">
          <a-select
            class="a-select"
            ref="select"
            placeholder="请选择"
            v-model:value="formState.lineId"
            @change="lineChange"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in lineLists"
            >{{item.lineName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="桥梁名称">
          <a-select
            class="a-select"
            ref="select"
            placeholder="请选择"
            v-model:value="formState.bridgeId"
            @change="bridgeChange"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in bridgeLists"
            >{{item.bridgeName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="设备名称">
          <a-select
            class="a-select"
            ref="select"
            placeholder="请选择"
            v-model:value="formState.deviceUuid"
            @change="deviceChange"
          >
            <a-select-option
              :value="item.deviceUuid"
              v-for="(item, i) in deviceLists"
            >{{item.deviceName}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="阈值"
          class="table"
        >
          <a-row>
            <a-col>业务参数</a-col>
            <a-col>阈值一级</a-col>
            <a-col>阈值二级</a-col>
            <a-col>阈值三级</a-col>
          </a-row>
          <a-row v-for="(item, i) in present.iotThresholdItemVos">
            <a-col>{{item.parameterName}}</a-col>
            <a-col>
              <a-input
                class="tableIpt"
                type="number"
                v-model:value="item.firstLevelThreshold"
              />
            </a-col>
            <a-col>
              <a-input
                class="tableIpt"
                type="number"
                v-model:value="item.secondaryThreshold"
              />
            </a-col>
            <a-col>
              <a-input
                class="tableIpt"
                type="number"
                v-model:value="item.tertiaryThreshold"
              />
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import { alterThreshold } from "@/api/warning/warning.js";
import { bridgeTree, deviceTree } from "@/api/index/index.js";
import { physicalModel } from "@/api/datas/datas.js";

export default {
  name: "alterEarly",
  data() {
    return {
      visible: false,
      formState: {
        lineId: '',
        bridgeId: '',
        deviceUuid: '',
        alarmItems: []
      },
      measurements: [],
      labelCol: {
        span: 4
      },
      query: {
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  props: ['lineLists', 'bridgeLists', 'deviceLists', 'present'],
  updated() {
    this.formState = this.present
    if (this.present) {
      this.formState.alarmItems = []
      this.deviceInit(this.present.deviceUuid)
      console.log(this.formState)
    }
  },
  mounted() {

  },
  methods: {
    show() {
      this.visible = true
    },
    lineChange(value) {
      // console.log(value)
      this.formState.bridgeId = ''
      this.formState.deviceUuid = ''
      bridgeTree({ lineId: value }).then(res => { //桥梁列表
        if (res.code == 200) {
          this.bridgeLists = res.data
        }
      }).catch(res => {
        console.log(res)
      });
    },
    bridgeChange(value) {
      // console.log(value)
      this.formState.deviceUuid = ''
      deviceTree({ bridgeId: value }).then(res => { //设备列表
        if (res.code == 200) {
          this.deviceLists = res.data
        }
      }).catch(res => {
        console.log(res)
      });
    },
    deviceChange(value) {
      // console.log(value)
      var modelId = ''
      for (let i = 0; i < this.deviceLists.length; i++) {
        const element = this.deviceLists[i];
        if (element.deviceUuid == value) {
          modelId = element.modelId
        }
      }
      physicalModel({ modelId: modelId }).then(res => { //物理模型
        if (res.code == 200) {
          this.measurements = res.data.measurements
          for (let i = 0; i < this.measurements.length; i++) {
            this.formState.alarmItems[i] = {
              parameter: this.measurements[i].measName,
              firstLevelThreshold: 0,
              secondaryThreshold: 0,
              tertiaryThreshold: 0,
            }
          }
        }
      }).catch(res => {
        console.log(res)
      });
    },
    deviceInit(value) {
      // console.log(value)
      var modelId = ''
      for (let i = 0; i < this.deviceLists.length; i++) {
        const element = this.deviceLists[i];
        if (element.deviceUuid == value) {
          modelId = element.modelId
        }
      }
      physicalModel({ modelId: modelId }).then(res => { //物理模型
        if (res.code == 200) {
          this.measurements = res.data.measurements
          for (let i = 0; i < this.measurements.length; i++) {
            this.formState.alarmItems[i] = {
              parameter: this.measurements[i].measName,
              firstLevelThreshold: '',
              secondaryThreshold: '',
              tertiaryThreshold: '',
            }
          }
          console.log(this.formState)
        }
      }).catch(res => {
        console.log(res)
      });
    },
    //保存
    handleOk() {
      alterThreshold(this.formState).then(res => {
        if (res.code === 200) {
          this.visible = false
          this.$emit('confirm')
          this.$message.success(res.data);
        }
      })
    },
  }
};
</script>
<style scoped>
.addUser :deep() .ant-modal-title {
  padding-left: 10px;
  margin-top: 20px;
  vertical-align: top;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222222;
  border-left: 5px solid #0088ff;
}
.ant-modal-header {
  border: 0;
}
.addUser :deep() .ant-modal-body {
  padding: 24px 50px 40px;
}
.addUser :deep() .ant-form-item-label > label {
  height: 40px;
}
.ipt {
  width: 343px;
  height: 40px;
  background: #fefefe;
  border-radius: 6px;
}
.a-select :deep() .ant-select-selector {
  height: 38px;
  border-radius: 6px;
}
.a-select :deep() .ant-calendar-picker {
  width: 100%;
}
.a-select :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 40px;
  border-radius: 6px;
}
/* .a-select :deep() .ant-select-selector {
  width: 236px;
  height: 40px;
  border-radius: 6px;
} */
.a-select :deep() .ant-select-selection-item,
.a-select :deep() .ant-select-selection-placeholder {
  line-height: 38px !important;
  line-height: 38px;
}
.addUser :deep() .ant-form-item-control-input {
  height: 40px;
}
.addUser :deep() .ant-btn:nth-child(1) {
  width: 110px;
  height: 40px;
  color: #0088ff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.addUser :deep() .ant-btn-primary {
  width: 110px;
  height: 40px;
  margin: 10px 0 10px 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.addUser .del2 :deep() .ant-modal-header {
  display: none;
}
.table :deep() .ant-form-item-control-input {
  height: auto;
}
.table {
  max-height: 400px;
  justify-content: space-between;
  align-items: baseline;
}
.table :deep() .ant-form-item-control-input-content {
  max-height: 400px;
  overflow-y: scroll;
}
.table .ant-row .ant-col {
  width: 20%;
  line-height: 36px;
  text-align: center;
  border: 0.5px solid #ddd;
}
.table .ant-row .ant-col:nth-child(1) {
  width: 40%;
}
.table .ant-row .ant-col:nth-child(2) {
  color: rgb(248, 27, 27);
}
.table .ant-row .ant-col:nth-child(3) {
  color: #f87d09;
}
.table .ant-row .ant-col:nth-child(4) {
  color: #f7d30b;
}
.tableIpt {
  height: 36px;
  border: 0;
}
</style>
